import { FC, useContext, useEffect, useState } from 'react'
import { BudgetContext } from '../../../../lib/Context'
import { useFormatCurrency } from '../../../../lib/CurrencyFormatter'
import { Spend, Reconciliation } from '../../../../lib/Types'
import { useBudget, useBudgetReconciliations } from '../../lib/Hooks/Budget'
import { MdEdit } from 'react-icons/md'

interface Props {
  spend: Spend
}
const ReconciliationColumn: FC<Props> = ({ spend }) => {
  const formatCurrency = useFormatCurrency()
  const { setReconciliationToEdit, reconciliationYear } = useContext(BudgetContext)
  const { data: budget } = useBudget()
  const { data: reconciliations } = useBudgetReconciliations(budget!, reconciliationYear)
  const [reconciliation, setReconcilitation] = useState<Reconciliation>({ spend_id: spend.id, budget_id: budget!.id, year: reconciliationYear, formula: '', amount: 0 })

  useEffect(() => {
    if (reconciliations) {
      const reconciliationFound = reconciliations!.find((currentReconciliation: Reconciliation) => currentReconciliation.spend_id === spend.id)

      if (reconciliationFound) {
        setReconcilitation(reconciliationFound)
      }
    }
  }, [reconciliations])

  return (
    <div className="flex cursor-pointer" onClick={() => setReconciliationToEdit({ reconciliation, spend })}>
      <span>{reconciliation ? formatCurrency(reconciliation.amount) : 0}</span>
      <MdEdit size="1.15rem" className="mr-1" color="gray" />
    </div>
  )
}

export default ReconciliationColumn
